<template>
	<div>
		<button @click="closeModal">
      <img style="width: 40px" src="../../../../static/images/close-grey.svg" />
    </button>
		<div class="d-flex justify-center">
			<v-card width="720">
				<v-card-title class="text-h5 white lighten-1">
					Editar formulário
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="d-flex flex-column">
						<label class="mt-5 mb-2">ID Facebook</label>
						<input
							ref="id_email"
							v-model="item.id_form"
							class="b rounded">
						<label class="mt-5 mb-2" fro="id_email">XPROMO</label>
						<input
							ref="id_email"
							v-model="item.id_source"
							class="b rounded"
						>
						<label class="mt-5 mb-2">List Code</label>
						<input
							ref="id_email"
							v-model="item.list_code"
							class="b rounded"
						>
						<label class="mt-5 mb-2">Página email</label>
						<input
							ref="id_email"
							v-model="item.email_page"
							class="b rounded"
						>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							width="120"
							height="50"
							class="ma-3"
							color="var(--red)"
							:disabled="disabled"
							@click="onSubmit"
						>
							<img class="mr-2" src="../../../../static/images/save.svg" />
							Salvar
						</v-btn>
					</v-card-actions>
			</v-card>
		</div>
	</div>
</template>
<script>
//Lib
import { mapActions, mapMutations, mapState } from 'vuex'

//mixins
import toaster from '../../../mixins/toaster.js'

export default {
	mixins: [
		toaster
	],
	data () {
		return {
			disabled: false
		}
	},
	computed: {
		...mapState('Facebook', {
			item: 'facebookToEdit',
      loading: "loading",
		})
	},
	methods: {
		...mapActions("Facebook", [
      "getAllForms",
      "updateFacebook",
    ]),
		...mapMutations("Facebook", {
      setLoading: "SET_LOADING",
    }),
		closeModal () {
      this.$emit('close')
    },
		async onSubmit() {
      this.setLoading(true);
      this.disabled = true;
      await this.handleUpdate();
      this.setLoading(false);
    },
		async handleUpdate() {
      const { id_form, id_source, list_code, email_page, id } = this.item;

      if (id_form.length <= 20) {
        const token = window.localStorage.getItem("authToken");
        try {
          const response = await this.updateFacebook([
            {
              ...this.item,
              id,
              id_form,
              id_source,
              list_code,
              email_page,
              updated_at: new Date(),
              created_at: new Date(),
            },
            token,
          ]);

					await this.getAllForms({ token: token });
          this.closeModal();

          if (response.status >= 400) {
            throw new Error(response.data.message);
          } else {
            this.toaster("Formulário atualizado com sucesso", "success", true);
          }
        } catch (e) {
          return e;
        }
      } else {
        this.toaster(
          `O valor de ID do Formulário não pode ser maior que 20 caracteres`,
          "warning",
          true
        );
        this.disabled = false;
      }
    },
		checkContent() {
      const { id_form, id_source, list_code, email_page } = this.item;

      return id_form && id_source && list_code && email_page;
    },
		validate() {
      if (this.checkContent()) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
	},
	watch: {
    "item.id_form"() {
      this.validate();
    },
    "item.id_source"() {
      this.validate();
    },
    "item.list_code"() {
      this.validate();
    },
    "item.email_page"() {
      this.validate();
    },
  },
}
</script>
<style scoped>
.b {
	border: 2px solid var(--grey-day-030);
}

label {
  font-size: 16px;
}

input {
  padding-left: 8px;
  height: 48px;
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/Facebook/FacebookEdit.vue